<script>
  import Footer from "../components/Footer.svelte";
  import Header from "../components/Header.svelte";
  import LandingHeader from "../components/LandingHeader.svelte";
  import Notification from "../components/Notification.svelte";
  import emailjs from "emailjs-com";

  let firstName = "";
  let lastName = "";
  let email = "";
  let phoneNumber = "";
  let message = "";

  let toastMessage = "";
  let notificationType = "";
  let showToast = false;

  const serviceID = "service_pi4ixaq";
  const templateID = "template_t5o0nyw";
  const userID = "1BNWVR2DcIGPph14X";

  async function handleSubmit() {
    const templateParams = {
      to_name: "TruLens Support",
      from_name: `${firstName} ${lastName}`,
      email,
      phone_number: phoneNumber,
      message,
    };

    try {
      await emailjs.send(serviceID, templateID, templateParams, userID);

      toastMessage =
        "Thank you for reaching out! We'll get back to you shortly.";
      notificationType = "success";
      showToast = true;
      resetForm();

      setTimeout(() => {
        showToast = false;
      }, 3000);
    } catch (error) {
      console.error("EmailJS Error:", error);

      toastMessage =
        "There was an issue sending your request. Please try again later.";
      notificationType = "danger";
      showToast = true;

      setTimeout(() => {
        showToast = false;
      }, 3000);
    }
  }

  function resetForm() {
    firstName = lastName = email = phoneNumber = message = "";
  }
</script>

<LandingHeader />
<br />

<Notification
  message={toastMessage}
  show={showToast}
  type={notificationType}
  on:close={() => (showToast = false)}
/>

<div class="card-container">
  <div class="card-left">
    <h3 style="color: gray;">Support</h3>
    <h1>Customer Support</h1>
    <p style="color: gray;">
      Need help? We’re here to assist you.
      <br /><br />
      Fill out this quick form, and we’ll get back to you shortly.
      <br /><br />
      Reach us directly at <span style="color: blue;">admin@trulens.ae</span> or
      <span style="color: blue;">+971 012 345-6789</span>
    </p>
  </div>

  <div class="card-right">
    <div class="form-container">
      <form on:submit|preventDefault={handleSubmit} class="contact-form">
        <div class="name-container">
          <div class="name-field">
            <label for="firstName">First Name</label>
            <input type="text" bind:value={firstName} required id="firstName" />
          </div>
          <div class="name-field">
            <label for="lastName">Last Name</label>
            <input type="text" bind:value={lastName} required id="lastName" />
          </div>
        </div>

        <label for="email">Email</label>
        <input type="email" bind:value={email} required id="email" />

        <label for="phone">Phone Number</label>
        <input type="tel" bind:value={phoneNumber} required id="phone" />

        <label for="message">Message and any additional details:</label>
        <textarea bind:value={message} required id="message"></textarea>

        <button type="submit" class="button-submit">Submit</button>
      </form>
    </div>
  </div>
</div>

<br /><br />

<Footer />

<style>
  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: Arial, sans-serif;
    overflow-x: hidden; /* Prevent horizontal scroll */
  }

  h1 {
    font-size: 1.5em;
  }

  h3 {
    font-size: 1em;
  }

  .card-container {
    display: flex;
    flex-direction: column; /* Stack elements on small screens */
    width: 90%;
    max-width: 1000px; /* Set max width */
    margin: auto;
    padding: 1.5%; /* Remove padding */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    background-color: #f9f9f9;
  }

  @media (min-width: 768px) {
    .card-container {
      flex-direction: row; /* Row layout for larger screens */
    }

    .card-left {
      padding-right: 20px; /* Adjusted padding */
      flex: 1;
    }

    .card-right {
      flex: 1;
    }

    h1 {
      font-size: 2.5em;
    }

    h3 {
      font-size: 1.5em;
    }
  }

  .form-container {
    background-color: #f0f0f0;
    padding: 15px; /* Keep some padding */
    border-radius: 8px;
  }

  .contact-form {
    display: flex;
    flex-direction: column;
    gap: 10px; /* Maintain a bit of space */
    padding: 5px;
  }

  .name-container {
    display: flex;
    flex-wrap: wrap; /* Allow wrapping on small screens */
    gap: 10px; /* Maintain some gap */
  }

  .name-field {
    flex: 1;
    min-width: 120px; /* Minimum width for name fields */
  }

  input,
  textarea,
  select {
    width: 100%;
    padding: 10px; /* Sufficient padding for touch targets */
    border: 1px solid #ccc;
    border-radius: 4px;
    margin: 0; /* Remove margin */
  }

  label {
    margin-bottom: 5px; /* Slightly more space above labels */
  }

  .button-submit,
  .button-support {
    background-color: #4423ff;
    color: white;
    padding: 10px; /* Sufficient padding for touch targets */
    border: none;
    cursor: pointer;
    margin-top: 10px; /* Space above buttons */
  }

  .button-submit:hover,
  .button-support:hover {
    background-color: #1c00b9;
  }
</style>
